import Stack from '@mui/material/Stack';
import Pagination, { paginationClasses } from '@mui/material/Pagination';

import { usePagination } from 'src/hooks/use-pagination';

import { ButtonLoadMore } from 'src/components/custom-buttons';

import { ReviewItem } from './review-item';

// ----------------------------------------------------------------------

export function ReviewList({
  id,
  uid,
  reviews,
  perPage,
  reviewHook,
  loadingMore,
  totalReviews,
  loadMoreReviews,
}) {
  const DATA = usePagination(reviews, perPage);

  const isLastPage = DATA.currentPage === Math.ceil(totalReviews / perPage) - 1;

  return (
    <Stack sx={{ mb: 5 }}>
      {DATA.currentData().map((review) => (
        <ReviewItem key={review.id} id={id} uid={uid} review={review} reviewHook={reviewHook} />
      ))}

      <ButtonLoadMore
        perPage={perPage}
        total={totalReviews}
        loading={loadingMore}
        showing={reviews.length}
        onClick={loadMoreReviews}
        otherCondition={isLastPage}
        sx={{ mt: 4 }}
      />

      {reviews.length > perPage && (
        <Pagination
          count={DATA.maxPage}
          page={DATA.currentPage}
          onChange={(event, page) => DATA.jump(page)}
          sx={{
            mx: 'auto',
            [`& .${paginationClasses.ul}`]: { my: 5, mx: 'auto', justifyContent: 'center' },
          }}
        />
      )}
    </Stack>
  );
}
